import React, { Component } from 'react';
import Auth from '@aws-amplify/auth';
import Hello from './Hello';
import Unauth from './Unauth';

class Navbar extends Component {
  constructor(props) {
    super(props);
    //this.handleAnalyticsClick = this.handleAnalyticsClick.bind(this);
    this.state = {
      user: false
    };
    this.isLogged();
  }

  isLogged = () => {
    let _this = this;
    try {
      // setError(null);
      // setLoading(true);

      Auth.currentAuthenticatedUser({
        bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      }).then(user => {

        _this.setState({"user" :user});
        //setUser(user);
        //console.log(`Load additional settings for user: ${user.username}`);
        // TBD
      }).catch(err => {
        // setError(err);
        // setUser(user);
      });
    }
    catch (e) {
      // setError(e);
      // setUser(user);
    }
    finally {
      //setLoading(false);
    }
  }
  //this.isLogged();
  render() {
    //let output =  this.state.user === false ? ">>>" : <Hello />
    let greeting;


    if (this.state.user) {
      greeting = <Hello />;
    } else {
      greeting = <Unauth />;
    }

    return (
      <div>
        {greeting}
      </div>
    );
  }
}

export default Navbar;
